module.exports = __webpack_public_path__ + "img/jeremy.0f4118aa.png";